import { Navigate } from "react-router-dom";

const safeParse = (key) => {
  try {
    const v = sessionStorage.getItem(key);
    return v ? JSON.parse(v) : null;
  } catch {
    return null;
  }
};

// ✅ For Login/Register pages
export function PublicRoute({ children }) {
  const authSession = safeParse("authSession");

  // If logged in → redirect based on role
  if (authSession) {
    const role = authSession.role?.toString().toLowerCase();

    if (role === "astrologer") {
      return <Navigate to="/astrologer/home" replace />;
    }
    if (role === "user") {
      return <Navigate to="/" replace />;
    }

    // fallback
    return <Navigate to="/" replace />;
  }

  return children;
}

// ✅ For Protected pages
export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const authSession = safeParse("authSession");

  if (!authSession) {
    return <Navigate to="/login" replace />;
  }

  // Expiry check
  const now = Date.now();
  const tokenExpiry = authSession.token_expires_at
    ? new Date(authSession.token_expires_at).getTime()
    : null;

  if (tokenExpiry && now > tokenExpiry) {
    sessionStorage.removeItem("authSession");
    return <Navigate to="/login" replace />;
  }

  const role = authSession.role?.toString().toLowerCase() || null;

  if (allowedRoles.length > 0 && (!role || !allowedRoles.includes(role))) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
